import { mergeStyles } from '../../../../../../../internal/utils/mergeStyles';
import { getSizeStyles } from './size/getSizeStyles';
import * as styles from './styles.module.css';
export function getTabletDesktopStyles(size) {
  var deviceStyles = styles;
  var sizeStyles = getSizeStyles(size);
  return mergeStyles(deviceStyles, sizeStyles);
}